class Header {
    constructor() {
        this.init();
    }

    init() {
    }

    static RWDMenu() {
        const hamburgers = document.querySelectorAll('.hamburger');
        if (!hamburgers.length) return false;

        const nav = document.querySelector('.nav--mobile');
        if (nav === null) return false;

        hamburgers.forEach(hamburger => {
            hamburger.addEventListener('click', e => {
                nav.classList.toggle('is-open');
                hamburgers.forEach(hamburger => {
                    hamburger.classList.toggle('is-active');
                })
            });
        })
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/assets/js/components/Header.js